import { axios } from 'lib/axios';

export const initialPayment = () => {
  return axios.post('/payments/initial');
};
